// extracted by LIB_CSS_EXTRACT_LOADER
import "./visually-hidden_module.css"
export default {"visuallyHidden":"visuallyHidden-FBbBqV"};